<template>
  <tr>
    <td class="w-full">{{ category.name | nullable }}</td>
    <td class="w-full">{{ category.currency ? category.currency : 'None' | sentenceCase }}</td>
    <td class="w-full">{{ category.hide_budget }}</td>
    <td>
      <button class="edit-button" @click="$emit('edit', category.id)">
        <i class="fa fa-fw fa-pencil-square-o" />
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    category: {
      required: true,
      type: Object
    }
  }
}
</script>
